import { AssetStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/asset_pb';
import { DriverStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/driver_pb';
import { RouteStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/route_pb';
import { ServiceStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/service_pb';
import { TrailerStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/trailer_pb';
import { TruckStatus } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/truck_pb';

export const assetStatusLabels: Record<AssetStatus, string> = {
  [AssetStatus.UNSPECIFIED]: 'Unspecified',
  [AssetStatus.INVENTORY]: 'Inventory',
  [AssetStatus.DEPLOYED]: 'Deployed',
  [AssetStatus.IN_TRANSIT]: 'In Transit',
  [AssetStatus.OUT_OF_ORDER]: 'Out of Order',
};

export const driverStatusLabels: Record<DriverStatus, string> = {
  [DriverStatus.UNSPECIFIED]: 'Unspecified',
  [DriverStatus.AVAILABLE]: 'Available',
  [DriverStatus.ON_DUTY]: 'On Duty',
  [DriverStatus.OFF_DUTY]: 'Off Duty',
  [DriverStatus.ON_BREAK]: 'On Break',
  [DriverStatus.INACTIVE]: 'Inactive',
};

export const truckStatusLabels: Record<TruckStatus, string> = {
  [TruckStatus.UNSPECIFIED]: 'Unspecified',
  [TruckStatus.AVAILABLE]: 'Available',
  [TruckStatus.IN_USE]: 'In Use',
  [TruckStatus.INACTIVE]: 'Inactive',
  [TruckStatus.OUT_OF_SERVICE]: 'Out of Service',
};

export const trailerStatusLabels: Record<TrailerStatus, string> = {
  [TrailerStatus.UNSPECIFIED]: 'Unspecified',
  [TrailerStatus.AVAILABLE]: 'Available',
  [TrailerStatus.IN_USE]: 'In Use',
  [TrailerStatus.INACTIVE]: 'Inactive',
  [TrailerStatus.OUT_OF_SERVICE]: 'Out of Service',
};

export const routeStatusLabels: Record<RouteStatus, string> = {
  [RouteStatus.ACTIVE]: 'Active',
  [RouteStatus.COMPLETED]: 'Completed',
  [RouteStatus.FAILED]: 'Failed',
  [RouteStatus.IN_PROGRESS]: 'In Progress',
  [RouteStatus.PAUSED]: 'Paused',
  [RouteStatus.PLANNED]: 'Planned',
  [RouteStatus.UNSPECIFIED]: 'Unspecified',
  [RouteStatus.VOIDED]: 'Voided',
};

export const serviceStatusLabels: Record<ServiceStatus, string> = {
  [ServiceStatus.ACTIVE]: 'Active',
  [ServiceStatus.COMPLETED]: 'Completed',
  [ServiceStatus.DRAFT]: 'Draft',
  [ServiceStatus.FAILED]: 'Failed',
  [ServiceStatus.IN_PROGRESS]: 'In Progress',
  [ServiceStatus.PAUSED]: 'Paused',
  [ServiceStatus.PLANNED]: 'Planned',
  [ServiceStatus.UNSPECIFIED]: 'Unspecified',
  [ServiceStatus.VOIDED]: 'Voided',
};
